/* eslint-disable react/jsx-props-no-spreading */
import { AuthHeaderBox } from './styles';

const AuthHeader = (): JSX.Element => {
  return <AuthHeaderBox />;
  // <UPLogo />;
  // </AuthHeaderBox>;
};

export default AuthHeader;
